import React from 'react';
import { DownloadIcon, DropletsIcon, HammerIcon, HomeIcon, LayersIcon, ShieldIcon, SprayCanIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  roof: HomeIcon,
  drywall: LayersIcon,
  wood: HammerIcon,
  sealing: DropletsIcon,
  cleaning: SprayCanIcon,
  prevention: ShieldIcon
};
export function MaintenanceTips() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-cream py-16 lg:py-20" data-id="element-180" data-mp="c3j7gdeehvm4">
      <div className="mx-auto max-w-shell px-4 sm:px-6 lg:px-8" data-id="element-181" data-mp="c42rq0riww3b">
        <SectionHeading title={t.care.title} subtitle={t.care.subtitle} data-id="element-182" data-mp="g5o2ngkhz0av" />

        <ul className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8" data-id="element-183" data-mp="l492hevu7hys">
          {t.care.items.map((item, index) => {
          const Icon = icons[item.id] ?? DropletsIcon;
          return <Reveal as="li" key={item.id} delay={Math.min(index, 5) * 0.04} className="h-full" data-id="element-184" data-mp="27afvohudlbaa" data-mpi={index}>
                <article className="flex h-full flex-col border-t-4 border-brand-500 bg-white p-7 shadow-card" data-id="element-185" data-mp="22abndf3mfmv5">
                  <Icon className="h-8 w-8 text-brand-500" aria-hidden="true" data-id="element-186" data-mp="1ya9jr0ebsjd8" />
                  <h3 className="mt-5 font-display text-lg font-extrabold uppercase tracking-wide text-ink" data-id="element-187" data-mp="1taok0nrc06zg">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#5B5B5B]" data-id="element-188" data-mp="2q2ihs8psdjrx">{item.description}</p>
                </article>
              </Reveal>;
        })}
        </ul>

        <Reveal delay={0.1} data-id="element-189" data-mp="2h69g0nec692m">
          <div className="mt-12 text-center" data-id="element-190" data-mp="2c90waidjhwz9">
            <a href="#contact" className="inline-flex items-center gap-2 rounded bg-ink px-7 py-4 font-display text-sm font-extrabold uppercase tracking-wide text-white transition-colors duration-200 ease-smooth hover:bg-brand-500 hover:text-ink" data-id="element-191" data-mp="2c87wk1d007qm">
              <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-192" data-mp="3nuyhrj62nt1c" />
              {t.care.cta}
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}